import {
  Column,
  CreateDateColumn,
  DeleteDateColumn,
  Entity,
  OneToMany,
  PrimaryGeneratedColumn
} from 'typeorm';
import Pedido from './Pedido';

@Entity({ name: 'entregador' })
export class Entregador {
  @PrimaryGeneratedColumn()
  id!: number;

  @Column()
  nome: string = '';

  @Column({ unique: true, length: 11 })
  celular: string = '';

  @OneToMany(() => Pedido, (ped: Pedido) => ped.entregador)
  pedidos!: Pedido[];

  @CreateDateColumn({ select: false })
  createdAt!: Date;

  @DeleteDateColumn({ select: false })
  deletedAt!: Date;

  // @OneToMany(() => Endereco, (endereco: Endereco) => endereco.cliente, { cascade: true, eager: true })
  // enderecos?: Endereco[];

  // @OneToMany(() => Pedido, (pedido: Pedido) => pedido.cliente)
  // pedidos!: Pedido[];
}

export default Entregador;
